module.exports = __webpack_public_path__ + "static/media/biIcon.b8497fed.svg";